import {CSSProperties} from '../../../styleSheet';
import {
  DeviceClassName,
  DeviceSizeRanges,
  ResponsiveStyle,
  StyleCategoryName,
} from '../../base/types';
import {
  getResponsiveBaseStylePrDeviceClass,
  getStylePropertiesFromCategoriesAndCustomStyle,
} from '../../base/functions';
import {BaseResponsiveLayoutStyles} from '../types';
import {getCustomBaseStyle} from './getCustomBaseStyle';

export const getResponsiveBaseStyles = (
  categories: StyleCategoryName[],
  responsiveProps: BaseResponsiveLayoutStyles,
  deviceRanges: DeviceSizeRanges,
): CSSProperties | undefined => {
  const perClassStyles = Object.keys(responsiveProps).reduce<ResponsiveStyle>(
    (acc, key) => {
      const name = key as DeviceClassName;
      const customStyle = getCustomBaseStyle(responsiveProps[name]);
      const style = getStylePropertiesFromCategoriesAndCustomStyle(
        categories,
        responsiveProps[name],
        customStyle,
      );

      acc[name] = style;
      return acc;
    },
    {},
  );

  return getResponsiveBaseStylePrDeviceClass(perClassStyles, deviceRanges);
};
